import { Injectable } from '@angular/core';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util/is-null-or-defined';
import type { Itinerary } from '../../models/itinerary';
import { RestSanitizer } from '../rest-sanitizer.interface';
import { RideRequestSanitizer } from '../ride-request/ride-request.sanitizer';

@Injectable({
  providedIn: 'root'
})
export class ItinerarySanitizer implements RestSanitizer<Itinerary> {
  constructor(private rideRequestSanitizer: RideRequestSanitizer) {}

  sanitize(itinerary: Itinerary): Itinerary {
    if (isNullOrUndefined(itinerary)) {
      return itinerary;
    }

    itinerary.rideRequests?.map(rideRequest => this.rideRequestSanitizer.sanitize(rideRequest));

    return itinerary;
  }
}
